import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import FilterMetaLayout from '../../components_v1/filtersRow/FilterMetaLayout'
import { getPlanEntryGridState } from '../../../javascript/redux/selectors/planEntries'
import { class_series_finder_filter_event } from 'gtm/pushEvents'

// Redux
import {
  loadPlanEntries,
  addFilter,
  removeFilter,
  changeOrder,
  setInitialFilters,
  clearFilter,
  changeLayout,
  clearPlanEntries,
  clearAllFilters
} from '../../../javascript/redux/actions/planEntries'

// Filter Row Components
import FilterLabelsRow from '../../components_v1/filtersRow/FilterLabelsRow'
import FilterRowDropdownItem from '../../components_v1/filtersRow/FilterRowDropdownItem'
import FilterRowDropdown from '../../components_v1/filtersRow/FilterRowDropdown'
import { getCategoryRelationships } from '../../../javascript/redux/selectors/planCategoryPlanSubcategories'

// Helper Methods
import {
  getFilteredItemLabels,
  getDifficultyIcon,
  getIntensityIcon,
  getTotalNumberOfFilters
} from '../../components_v1/pageLevelComponents/classFinder/classFinderHelperMethods'
import ClassFinderMobileFilter from '../../components_v1/pageLevelComponents/classFinder/ClassFinderMobileFilter'
import isEqual from 'lodash.isequal'
import { CompletedClassFilter } from '../../components_v1/pageLevelComponents/classFinder/CompletedClassFilter'
import CustomDuration from '../../components_v1/pageLevelComponents/classFinder/CustomDuration'

const FILTER_BY_FIELDS = {
  instructors: 'slug',
  styles: 'slug',
  intensities: 'level',
  type: 'type'
}

const classSortOptions = [
  { title: 'Newest', value: 'date' },
  { title: 'Oldest', value: 'oldest' },
  { title: 'Class Name A-Z', value: 'title' },
  { title: 'Program Name A-Z', value: 'plan' },
  { title: 'Duration Short-Long', value: 'durationShortToLong' },
  { title: 'Duration Long-Short', value: 'durationLongToShort' }
]
const completedSortOptions = [
  { title: 'Newest', value: 'date' },
  { title: 'Oldest', value: 'oldest' },
  { title: 'A-Z', value: 'title' },
  { title: 'Duration Short-Long', value: 'durationShortToLong' },
  { title: 'Duration Long-Short', value: 'durationLongToShort' }
]
const seriesSortOptions = [
  { title: 'Newest', value: 'date' },
  { title: 'Oldest', value: 'oldest' },
  { title: 'Recently Viewed', value: 'recentlyViewed' },
  { title: 'Program Name A-Z', value: 'series' }
]

const classSortOptionsValues = [
  'date',
  'oldest',
  'title',
  'plan',
  'durationShortToLong',
  'durationLongToShort'
]

const completedSortOptionsValues = [
  'date',
  'oldest',
  'az',
  'durationShortToLong',
  'durationLongToShort'
]

const seriesSortOptionsValues = ['date', 'oldest', 'recentlyViewed', 'az']

const durationOptions = [
  { title: '0-15 minutes', min: 0, max: 15 },
  { title: '15-30 minutes', min: 15, max: 30 },
  { title: '30-60 minutes', min: 30, max: 60 },
  { title: '60+ minutes', min: 60, max: null }
]

class MyPracticeFilter extends React.Component {
  constructor(props) {
    super(props)

    this.initialDuration = {
      min:
        this.props.preloadedFilters.min ||
        this.props.dropdownOptions?.duration.min,
      max: this.props.preloadedFilters.max
    }

    this.filterOptions = this.generateFilterOptions()

    this.state = {
      activeDropdown: '',
      displayedDurationMinMax: this.initialDuration
    }
    this.applyFilter = this.applyFilter.bind(this)
    this.reorderEntries = this.reorderEntries.bind(this)
    this.openNextDropdown = this.openNextDropdown.bind(this)
    this.generateFilterOptions = this.generateFilterOptions.bind(this)
    this.instructorFilterExcluded = this.instructorFilterExcluded.bind(this)
    this.pushWindowState = this.pushWindowState.bind(this)
    this.removeFilter = this.removeFilter.bind(this)
    this.updateDisplayedDuration = this.updateDisplayedDuration.bind(this)
    this.generateFilterDropdownObj = this.generateFilterDropdownObj.bind(this)
    this.clearAllFilters = this.clearAllFilters.bind(this)
    this.productTop = React.createRef()

    this.excludedFilters = this.instructorFilterExcluded()
      ? ['instructors']
      : []
  }

  componentDidUpdate(prevProps) {
    // this is to hide duration filter when programs option from type filter is selected
    if (
      !isEqual(
        prevProps.filteredAttributes?.type,
        this.props.filteredAttributes?.type
      )
    ) {
      this.filterOptions = this.generateFilterOptions()
    }

    // Shallow comparison of arrays inside the nested object
    if (
      !isEqual(
        prevProps.filteredAttributes?.duration,
        this.props.filteredAttributes?.duration
      ) ||
      !isEqual(
        prevProps.filteredAttributes?.instructors,
        this.props.filteredAttributes?.instructors
      ) ||
      !isEqual(
        prevProps.filteredAttributes?.difficulties,
        this.props.filteredAttributes?.difficulties
      ) ||
      !isEqual(
        prevProps.filteredAttributes?.intensities,
        this.props.filteredAttributes?.intensities
      ) ||
      !isEqual(
        prevProps.filteredAttributes?.focus_area,
        this.props.filteredAttributes?.focus_area
      ) ||
      !isEqual(
        prevProps.filteredAttributes?.yoga,
        this.props.filteredAttributes?.yoga
      ) ||
      !isEqual(
        prevProps.filteredAttributes?.fitness,
        this.props.filteredAttributes?.fitness
      ) ||
      !isEqual(
        prevProps.filteredAttributes?.mindfulness,
        this.props.filteredAttributes?.mindfulness
      ) ||
      !isEqual(
        prevProps.filteredAttributes?.wellness,
        this.props.filteredAttributes?.wellness
      ) ||
      !isEqual(
        prevProps.filteredAttributes?.skills,
        this.props.filteredAttributes?.skills
      ) ||
      !isEqual(
        prevProps.filteredAttributes?.excludeCompleted,
        this.props.filteredAttributes?.excludeCompleted
      ) ||
      !isEqual(
        prevProps.filteredAttributes?.equipment,
        this.props.filteredAttributes?.equipment
      ) ||
      !isEqual(
        prevProps.filteredAttributes?.type,
        this.props.filteredAttributes?.type
      )
    ) {
      if (
        this.props.fetchMyPracticeInfo &&
        this.props.parent_tab === this.props.currentTab &&
        prevProps.currentTab === this.props.currentTab
      ) {
        // passing third parameter as true to reset the my practice existing data
        this.props.fetchMyPracticeInfo({}, this.props.currentTab, true)
      }
    }
  }

  updateDisplayedDuration(displayedDurationMinMax) {
    this.setState({ displayedDurationMinMax })
  }

  userHasFiltered() {
    for (const label in this.props.filteredAttributes) {
      let userHasFiltered
      switch (label) {
        case 'duration':
          userHasFiltered =
            this.props.filteredAttributes?.duration?.min > 0 ||
            !!this.props.filteredAttributes?.duration?.max
          break
        case 'styles':
          userHasFiltered =
            Object.keys(this.props.filteredAttributes?.styles).length > 0
          break
        default:
          // userHasFiltered = this.props.filteredAttributes[label].length > 0
          userHasFiltered = this.props.filteredAttributes?.[label]?.length > 0
          break
      }
      if (userHasFiltered && !this.isLabelExcluded(label)) return true
    }
  }

  isLabelExcluded(label) {
    return this.excludedFilters.includes(label)
  }

  pushWindowState() {
    window.history.pushState(
      this.props.filteredAttributes,
      null,
      `${this.props.baseUrl}?${this.props.filterUrl}`
    )
  }

  generateFilterOptions() {
    // Object containing all class finder filter information
    return Object.assign(
      {},
      this.generateFilterDropdownObj(
        'sort',
        null,
        (autoOpen, noSlideAnimation) => {
          const sortOptions =
            this.props.parent_tab === 'classes'
              ? classSortOptions
              : this.props.parent_tab === 'completed'
              ? this.props.filteredAttributes?.type?.length === 1 &&
                this.props.filteredAttributes?.type[0]?.type === 'classes'
                ? completedSortOptions
                : completedSortOptions?.slice(0, -2)
              : seriesSortOptions
          return (
            <FilterRowDropdown
              open={this.state.activeDropdown === 'sort' || autoOpen}
              noSlideAnimation={noSlideAnimation}
              dropdownOptions={sortOptions}
              onAfterClose={this.openNextDropdown}
              renderDropdownItemTemplate={({ option }) => {
                return (
                  <FilterRowDropdownItem
                    active={this.props.order === option.value}
                    label={option.title}
                    handleItemClick={() => {
                      this.reorderEntries(option.value)
                    }}
                    isSort={true}
                  />
                )
              }}
            />
          )
        }
      ),
      this.props?.parent_tab === 'completed'
        ? this.generateFilterDropdownObj(
            'type',
            FILTER_BY_FIELDS.type,
            (autoOpen, noSlideAnimation) => (
              <FilterRowDropdown
                dropdownOptions={this.props.dropdownOptions?.type}
                noSlideAnimation={noSlideAnimation}
                onAfterClose={this.openNextDropdown}
                open={this.state.activeDropdown === 'type' || autoOpen}
                renderDropdownItemTemplate={({ option }) => {
                  const filteredType = this.props.filteredAttributes?.type?.map(
                    (typeItem) => typeItem.type
                  )
                  return (
                    <FilterRowDropdownItem
                      active={filteredType?.includes(option.type)}
                      label={option.label}
                      handleItemClick={() => {
                        if (filteredType?.includes(option.type)) {
                          this.removeFilter('type', option.type)
                        } else {
                          this.applyFilter('type', option)
                        }
                      }}
                    />
                  )
                }}
                parentLabel='type'
              />
            ),
            'Type'
          )
        : {},
      ...this.props.dropdownOptions?.styles.map((style) => {
        return this.generateFilterDropdownObj(
          style.slug,
          FILTER_BY_FIELDS.styles, //slug
          (autoOpen, noSlideAnimation) => {
            const allFilter = {
              title:
                this.props?.currentTab === 'completed'
                  ? `All ${style.title}`
                  : `All ${style.title} classes`,
              slug: style.slug
            }
            return (
              <FilterRowDropdown
                open={this.state.activeDropdown === style.slug || autoOpen}
                noSlideAnimation={noSlideAnimation}
                dropdownOptions={[allFilter].concat(
                  this.props.dropdownOptions?.styles.filter(
                    (firstLevelChild) => firstLevelChild.slug === style.slug
                  )[0].subcategories
                )}
                onAfterClose={this.openNextDropdown}
                renderDropdownItemTemplate={({ option, header, parent }) => {
                  const filteredCategory = this.props.filteredAttributes[
                    style.slug
                  ]?.map((item) => item.slug)

                  return (
                    <FilterRowDropdownItem
                      // isHeader={header}
                      active={filteredCategory?.includes(option.slug)}
                      label={option.title}
                      handleItemClick={() => {
                        if (filteredCategory?.includes(option.slug)) {
                          this.removeFilter(style.slug, option.slug)
                        } else {
                          this.applyFilter(style.slug, option)
                        }
                      }}
                    />
                  )
                }}
                tab={this.props.currentTab}
              />
            )
          },
          style.title
        )
      }),

      (this.props.parent_tab === 'completed' &&
        this.props.filteredAttributes?.type?.length === 1 &&
        this.props.filteredAttributes?.type[0]?.type === 'classes') ||
        this.props.parent_tab === 'classes'
        ? this.generateFilterDropdownObj(
            'duration',
            null,
            (autoOpen, noSlideAnimation) => {
              return (
                <FilterRowDropdown
                  open={this.state.activeDropdown === 'duration' || autoOpen}
                  noSlideAnimation={noSlideAnimation}
                  dropdownOptions={durationOptions}
                  bottomItems={() => (
                    <CustomDuration
                      removeFilter={this.removeFilter}
                      applyFilter={this.applyFilter}
                      durationOptions={durationOptions}
                      isFromClassFinderPage={false}
                    />
                  )}
                  onAfterClose={this.openNextDropdown}
                  renderDropdownItemTemplate={({ option }) => {
                    const filteredDuration =
                      this.props.filteredAttributes?.duration
                    const isActive = filteredDuration?.some((duration) => {
                      const durationValues = duration.split('-')
                      const filteredMinValue = Number(durationValues[0])
                      const filteredMaxValue =
                        durationValues[1] === 'null'
                          ? null
                          : Number(durationValues[1])
                      return (
                        filteredMinValue == option.min &&
                        filteredMaxValue == option.max
                      )
                    })
                    return (
                      <FilterRowDropdownItem
                        active={isActive}
                        label={option.title}
                        handleItemClick={() => {
                          if (isActive) {
                            this.removeFilter(
                              'duration',
                              `${option.min}-${option.max}`
                            )
                          } else {
                            this.applyFilter('duration', option)
                          }
                        }}
                      />
                    )
                  }}
                  tab={this.props.currentTab}
                />
              )
            }
          )
        : {},
      this.generateFilterDropdownObj(
        'focus_area',
        null,
        (autoOpen, noSlideAnimation) => (
          <FilterRowDropdown
            dropdownOptions={this.props.dropdownOptions?.focus_area}
            noSlideAnimation={noSlideAnimation}
            onAfterClose={this.openNextDropdown}
            open={this.state.activeDropdown === 'focus_area' || autoOpen}
            renderDropdownItemTemplate={({ option }) => {
              const filteredFocusArea =
                this.props.filteredAttributes?.focus_area
              return (
                <FilterRowDropdownItem
                  active={filteredFocusArea?.includes(option)}
                  label={option}
                  handleItemClick={() => {
                    if (filteredFocusArea?.includes(option)) {
                      this.removeFilter('focus_area', option)
                    } else {
                      this.applyFilter('focus_area', option)
                    }
                  }}
                />
              )
            }}
            parentLabel='focus_area'
            tab={this.props.currentTab}
          />
        ),
        'Focus Area'
      ),
      this.generateFilterDropdownObj(
        'equipment',
        null,
        (autoOpen, noSlideAnimation) => (
          <FilterRowDropdown
            dropdownOptions={this.props.dropdownOptions?.equipment}
            noSlideAnimation={noSlideAnimation}
            onAfterClose={this.openNextDropdown}
            open={this.state.activeDropdown === 'equipment' || autoOpen}
            renderDropdownItemTemplate={({ option }) => {
              const filteredEquipments =
                this.props.filteredAttributes?.equipment
              return (
                <FilterRowDropdownItem
                  active={filteredEquipments?.includes(option)}
                  label={option}
                  handleItemClick={() => {
                    if (filteredEquipments?.includes(option)) {
                      this.removeFilter('equipment', option)
                    } else {
                      this.applyFilter('equipment', option)
                    }
                  }}
                />
              )
            }}
            parentLabel='Equipment'
            tab={this.props.currentTab}
          />
        ),
        'Equipment'
      ),

      this.generateFilterDropdownObj(
        'difficulties',
        null,
        (autoOpen, noSlideAnimation) => (
          <FilterRowDropdown
            dropdownOptions={this.props.dropdownOptions?.difficulties}
            noSlideAnimation={noSlideAnimation}
            onAfterClose={this.openNextDropdown}
            open={this.state.activeDropdown === 'difficulties' || autoOpen}
            renderDropdownItemTemplate={({ option }) => {
              const filteredDifficulties =
                this.props.filteredAttributes?.difficulties
              return (
                <FilterRowDropdownItem
                  itemStyles={{ width: '65%' }}
                  itemClassName={['difficultyFilterItem']}
                  active={filteredDifficulties?.includes(option)}
                  label={option}
                  handleItemClick={() => {
                    if (filteredDifficulties?.includes(option)) {
                      this.removeFilter('difficulties', option)
                    } else {
                      this.applyFilter('difficulties', option)
                    }
                  }}
                  renderDecorator={() => getDifficultyIcon(option)}
                />
              )
            }}
            parentLabel='Difficulty'
            filterDesc='Difficulty refers to the level of skill and technique called for.'
            tab={this.props.currentTab}
          />
        ),
        'Difficulty'
      ),
      this.generateFilterDropdownObj(
        'intensities',
        FILTER_BY_FIELDS.intensities,
        (autoOpen, noSlideAnimation) => (
          <FilterRowDropdown
            additionalClassNames={['intensity-filter']}
            additionalOpenClass='overflow'
            open={this.state.activeDropdown === 'intensities' || autoOpen}
            noSlideAnimation={noSlideAnimation}
            dropdownOptions={this.props.dropdownOptions?.intensities}
            onAfterClose={this.openNextDropdown}
            renderDropdownItemTemplate={({ option }) => {
              const filteredIntensities =
                this.props.filteredAttributes?.intensities?.map(
                  (intensity) => intensity.level
                )
              return (
                <FilterRowDropdownItem
                  active={filteredIntensities?.includes(option.level)}
                  linkClassName='intensity-link'
                  label={`${option.level}`}
                  itemStyles={{ width: '38%' }}
                  itemClassName={['intensityFilterItem']}
                  handleItemClick={() => {
                    if (filteredIntensities?.includes(option.level)) {
                      this.removeFilter('intensities', option.level)
                    } else {
                      this.applyFilter('intensities', option)
                    }
                  }}
                  renderDecorator={() => getIntensityIcon(option.level)}
                  filterName={'Intensity'}
                />
              )
            }}
            parentLabel='Intensity'
            filterDesc='Intensity refers to the amount of exertion required.'
            tab={this.props.currentTab}
          />
        ),
        'Intensity'
      ),

      this.generateFilterDropdownObj(
        'instructors',
        FILTER_BY_FIELDS.instructors,
        (autoOpen, noSlideAnimation) => {
          const allInstructorsOption = {
            text: 'All Instructors'
          }
          return (
            <FilterRowDropdown
              open={this.state.activeDropdown === 'instructors' || autoOpen}
              dropdownOptions={[allInstructorsOption].concat(
                this.props.dropdownOptions?.instructors
              )}
              onAfterClose={this.openNextDropdown}
              noSlideAnimation={noSlideAnimation}
              renderDropdownItemTemplate={({ option }) => {
                const user = option.user
                const filteredInstuctorSlugs =
                  this.props.filteredAttributes?.instructors?.map(
                    (instructor) => instructor.slug
                  )

                if (user) {
                  return (
                    <FilterRowDropdownItem
                      active={filteredInstuctorSlugs?.includes(option.slug)}
                      label={`${user.firstName} ${user.lastName}`}
                      handleItemClick={() => {
                        if (filteredInstuctorSlugs?.includes(option.slug)) {
                          this.removeFilter('instructors', option.slug)
                        } else {
                          this.applyFilter('instructors', option)
                        }
                      }}
                    />
                  )
                } else {
                  // All instructors selected
                  return (
                    <FilterRowDropdownItem
                      active={
                        this.props.filteredAttributes?.instructors?.length === 0
                      }
                      label={option.text}
                      handleItemClick={() => {
                        class_series_finder_filter_event(
                          'instructors',
                          'all instructors'
                        )
                        this.props.clearFilter('instructors')
                        // this.props.loadPlanEntries(this.pushWindowState)
                        this.props.fetchMyPracticeInfo(
                          {},
                          this.props.selected_tab
                        )
                      }}
                    />
                  )
                }
              }}
              tab={this.props.currentTab}
            />
          )
        }
      )
    )
  }

  openNextDropdown() {
    if (this.state.toBeOpenDropdown) {
      const activeDropdown = this.state.toBeOpenDropdown
      this.setState({
        activeDropdown,
        toBeOpenDropdown: ''
      })
    }
  }

  /**
   * Generates an object for the Filter components
   * @param {Name of filter section.  This will be used as the display label if none is given} label
   * @param {Field to filter by} filterByField
   * @param {Function returning the component that will be displayed in the dropdown} renderDropdownContent
   * @param {Additional CSS classes to pass to dropdown element} additionalDropdownClasses
   * @param {Array of 'filterByFields' representing what the user has already filtered} filtered
   * @param {Label displayed in view} displayedLabel
   */
  generateFilterDropdownObj(
    label,
    filterByField,
    renderDropdownContent,
    displayedLabel,
    additionalDropdownClasses
  ) {
    if (
      label !== 'instructors' ||
      (label === 'instructors' && !this.instructorFilterExcluded())
    ) {
      return {
        [`${label}`]: {
          displayedLabel,
          additionalDropdownClasses,
          renderDropdownContent,
          filterByField,
          onClickFilterDropdown: (value) => {
            if (
              this.state.activeDropdown !== '' &&
              this.state.activeDropdown !== value
            ) {
              this.setState({
                toBeOpenDropdown: value,
                activeDropdown: ''
              })
            } else {
              const activeValue =
                this.state.activeDropdown === value ? '' : value
              this.setState({ activeDropdown: activeValue })
            }
          }
        }
      }
    }
  }

  applyFilter(filterSection, filter, options) {
    const maxRange = filter.max || this.props.dropdownOptions?.duration.max
    const excludeFilterEvent =
      filterSection === 'duration' &&
      filter?.min === this.props.dropdownOptions?.duration.min &&
      maxRange === this.props.dropdownOptions?.duration.max
    const durationFilter = {
      min: filter.min,
      max: maxRange
    }
    let filterValue = ''

    if (this.props.filteredAttributes) {
      switch (filterSection) {
        case 'instructors':
          filterValue = filter?.user?.name
          break
        case 'styles':
          filterValue = filter?.slug
          break
        case 'intensities':
          filterValue = String(filter?.level)
          break
        case 'duration':
          filterValue = `${durationFilter.min}-${durationFilter.max}`
          break
        case 'difficulties':
          filterValue = filter
          break
        case 'yoga':
        case 'fitness':
        case 'mindfulness':
        case 'wellness':
        case 'skills':
          filterValue = filter?.slug
          break
        case 'type':
          filterValue = filter?.type
          break
        default:
          filterValue = filter
          break
      }
    }

    !excludeFilterEvent &&
      class_series_finder_filter_event(filterSection, filterValue, options)
    this.props.addFilter(filterSection, filter, options)
    if (filterSection === 'type' && filter?.type === 'programs') {
      this.props.clearFilter('duration')
    }
  }

  removeFilter(filterSection, filter, options) {
    const filterOptions = this.filterOptions
    if (filterSection === 'duration') {
      this.setState({
        displayedDurationMinMax: {
          min: this.props.dropdownOptions?.duration.min
        }
      })
    }
    const filterByField = filterOptions?.[filterSection]?.filterByField
    this.props.removeFilter(filterSection, filter, filterByField, options)
    if (
      filterSection === 'type' &&
      filter === 'classes' &&
      this.props.filteredAttributes?.duration?.length
    ) {
      this.props.clearFilter('duration')
    }
  }

  clearAllFilters() {
    this.props.clearAllFilters()
    this.props.fetchMyPracticeInfo({}, this.props.selected_tab)
  }

  reorderEntries(order) {
    this.props.changeOrder(order)
  }

  instructorFilterExcluded() {
    return this.props.dropdownOptions?.instructors?.length < 2
  }
  getOrderForTab() {
    let order
    if (this.props.parent_tab === 'classes') {
      if (
        this.props.selectedClassesOptions.selectedColumn === 'date' &&
        this.props.selectedClassesOptions.sorting === 'asc'
      ) {
        order = 'oldest'
      } else if (
        this.props.selectedClassesOptions.selectedColumn === 'duration'
      ) {
        if (this.props.selectedClassesOptions.sorting === 'asc') {
          order = 'durationShortToLong'
        }
        if (this.props.selectedClassesOptions.sorting === 'desc') {
          order = 'durationLongToShort'
        }
      } else {
        order = this.props.selectedClassesOptions.selectedColumn
      }
    } else if (this.props.parent_tab === 'completed') {
      if (
        this.props.selectedCompletedClassOptions.selectedColumn === 'date' &&
        this.props.selectedCompletedClassOptions.sorting === 'asc'
      ) {
        order = 'oldest'
      } else if (
        this.props.selectedCompletedClassOptions.selectedColumn === 'duration'
      ) {
        if (this.props.selectedCompletedClassOptions.sorting === 'asc') {
          order = 'durationShortToLong'
        }
        if (this.props.selectedCompletedClassOptions.sorting === 'desc') {
          order = 'durationLongToShort'
        }
      } else {
        order = this.props.selectedCompletedClassOptions.selectedColumn
      }
    } else {
      order = this.props.selectedSeriesSortOption
    }
    return order
  }

  render() {
    const filteredLabels = getFilteredItemLabels({
      filteredAttributes: this.props.filteredAttributes,
      duration: {
        min: this.props.dropdownOptions?.duration.min,
        max: this.props.dropdownOptions?.duration.max
      },
      excludedFilters: this.excludedFilters || [],
      categoryRelationships: this.props.categoryRelationships
    })

    const totalfiltersSelected = getTotalNumberOfFilters(filteredLabels)
    return (
      <FilterMetaLayout
        filters={this.filterOptions}
        layout={this.props.layout}
        onLayoutSelect={this.props.selectLayout}
        modalFilterOptions={this.filterOptions}
        userHasFiltered={this.userHasFiltered()}
        totalProducts={this.props.totalCount}
        order={this.getOrderForTab()}
        durationOptions={durationOptions}
        renderTopRow={() => (
          <>
            {(this.props.parent_tab === 'classes' ||
              this.props.parent_tab === 'series') && (
              <CompletedClassFilter
                applyFilter={this.applyFilter}
                removeFilter={this.removeFilter}
                excludeCompleted={
                  this.props.filteredAttributes?.excludeCompleted
                }
              />
            )}
            <FilterLabelsRow
              filterOptions={this.filterOptions}
              activeDropdown={this.state.activeDropdown}
              excludedFilters={this.excludedFilters}
            />
          </>
        )}
        filteredLabels={filteredLabels}
        onSelectedFilterLabelClick={this.removeFilter}
        onSort={this.reorderEntries}
        sortableFields={
          this.props.parent_tab === 'classes'
            ? classSortOptionsValues
            : this.props.parent_tab === 'completed'
            ? this.props.filteredAttributes?.type?.length === 1 &&
              this.props.filteredAttributes?.type[0]?.type === 'classes'
              ? completedSortOptionsValues
              : completedSortOptionsValues?.slice(0, -2)
            : seriesSortOptionsValues
        }
        contentLabel='Classes'
        renderMobileFilters={({ isMobileFilterOpen, exitFullscreen }) => {
          return (
            <ClassFinderMobileFilter
              isOpen={isMobileFilterOpen}
              onHide={(userHasChangedFilter) => {
                exitFullscreen()
                if (userHasChangedFilter) {
                  // this.props.loadPlanEntries(this.pushWindowState)
                  this.props.fetchMyPracticeInfo({}, this.props.selected_tab)
                }
              }}
              withSubcategories={this.props.withSubcategories}
              filteredLabels={filteredLabels}
              filterOptions={this.props.dropdownOptions}
              noInstructors={this.instructorFilterExcluded()}
              filterByFields={FILTER_BY_FIELDS}
              onSelectedFilterLabelClick={this.removeFilter}
              onClearAll={this.clearAllFilters}
              totalfiltersSelected={totalfiltersSelected}
            />
          )
        }}
        onClearAll={this.clearAllFilters}
        totalfiltersSelected={totalfiltersSelected}
      />
    )
  }
}

const mapStateToProps = (state) => {
  const planEntryGridState = getPlanEntryGridState(state)
  return {
    filteredAttributes: state.ui.planEntries.filtered,
    filterUrl: state.ui.planEntries.filterUrl,
    total: parseInt(planEntryGridState.total),
    order: state.ui.planEntries.order,
    categoryRelationships: getCategoryRelationships(state),
    layout: planEntryGridState.layout
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadPlanEntries: (callback) => {
      dispatch(clearPlanEntries())
      dispatch(loadPlanEntries(callback))
    },
    addFilter: (filterSection, filters, options) => {
      dispatch(addFilter(filterSection, filters, options))
    },
    removeFilter: (filterSection, filterField, filterByField, options) => {
      dispatch(removeFilter(filterSection, filterField, filterByField, options))
    },
    changeOrder: (order) => {
      dispatch(changeOrder(order))
    },
    setInitialFilters: (filters) => {
      dispatch(setInitialFilters(filters))
    },
    selectLayout: (layout) => {
      dispatch(changeLayout(layout))
    },
    clearFilter: (label) => {
      dispatch(clearFilter(label))
    },
    clearAllFilters: () => {
      dispatch(clearAllFilters())
    }
  }
}

MyPracticeFilter.propTypes = {
  baseUrl: PropTypes.string,
  clearInstructorFilter: PropTypes.func,
  changeOrder: PropTypes.func,
  addFilter: PropTypes.func,
  filterUrl: PropTypes.string,
  removeFilter: PropTypes.func,
  loadPlanEntries: PropTypes.func,
  order: PropTypes.string,
  filteredAttributes: PropTypes.object,
  preloadedFilters: PropTypes.object,
  includeFilters: PropTypes.bool,
  setInitialFilters: PropTypes.func,
  total: PropTypes.number,
  clearFilter: PropTypes.func,
  selectLayout: PropTypes.func,
  withSubcategories: PropTypes.bool,
  dropdownOptions: PropTypes.object,
  layout: PropTypes.string
}

export default connect(mapStateToProps, mapDispatchToProps)(MyPracticeFilter)
